<div class="mb-2 h-[94px] !px-6 !py-8 rounded-lg bg-palette-blue-700 flex gap-2 items-center relative">
    <img width="124.5px" height="30px" src="assets/images/logo/white-logo-text.svg" alt="">
    <p class="text-white !text-lg font-semibold">{{'COMMON.FLIGHT' | translate:{syntax:''} }}</p>
    <img class="absolute bottom-0 right-0" src="assets/images/modules/vector_31.svg" alt="">
    <img class="absolute bottom-0 right-[15.68px] z-10 min-[0px]:max-[900px]:hidden"
        src="assets/images/modules/calendar.svg" alt="">
</div>